import { render, staticRenderFns } from "./LayoutContentMain.vue?vue&type=template&id=b007f548&scoped=true&"
import script from "./LayoutContentMain.vue?vue&type=script&lang=js&"
export * from "./LayoutContentMain.vue?vue&type=script&lang=js&"
import style0 from "./LayoutContentMain.vue?vue&type=style&index=0&id=b007f548&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b007f548",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBarNavIcon } from 'vuetify/lib/components/VAppBar';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VAppBarNavIcon,VOverlay})
